import io from "socket.io-client";
import { SOCKET_URL } from "../helpers/constants/urls";

const URL = SOCKET_URL;

export const socket = io(URL!, {
  autoConnect: false,
});
